import axios from "axios";
import Cookies from "js-cookie";

export const sendUpgradeRequest = async (
  full_name,
  email,
  organization_name
) => {
  const response = await axios
    .post(
      "/api/v1/upgrade_account/upgrade_request",
      {
        full_name: full_name,
        email: email,
        organization_name: organization_name,
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  return response.status;
};
